import type { SVGProps } from 'react';

export function PopularIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 17.27l-5.18 2.73 1-5.81L3 10l5.81-.85L12 4l2.19 5.15L20 10l-4.82 4.19 1 5.81z" />
    </svg>
  );
}
